import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppNumericInputComponent),
      multi: true
    }
  ]
})
export class AppNumericInputComponent implements ControlValueAccessor {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;

  // Internal value variable
  innerValue: string = '';

  // ControlValueAccessor Callback placeholders
  onChange: any = () => {};
  onTouch: any = () => {};

  // 1. Writes value from Parent model down into this child component
  writeValue(value: any): void {
    this.innerValue = value || '';
  }

  // 2. Registers the parent change handler method
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // 3. Registers the parent touched handler method
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // 4. Handles parent disabled states dynamically
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Fires when user types or changes input values locally
  onInputChange(val: string) {
    this.innerValue = val;
    this.onChange(val); // Passes the clean value back to Parent [(ngModel)]
  }

  handleKeyPress(event: KeyboardEvent): boolean {
    const pattern = /[a-zA-Z0-9]/;
    if (!pattern.test(event.key)) {
      return false;
    }
    return true;
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const cleanedText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
    this.onInputChange(cleanedText);
  }
}